<template>
  <v-flex class="cStatement" data-qa="internationalpaymentsreview-flex-x6ckh7">
    <div class="transferReview" data-qa="internationalpaymentsreview-div-rgb0ms">
      <v-layout wrap class="ml-2 transferFunds--gradientBGposition" data-qa="internationalpaymentsreview-layout-ukkwg">
        <v-flex
          xs12
          sm12
          md12
          lg12
          xl12
          :style="{ background: dashboardGradient, height: '180px' }"
         data-qa="internationalpaymentsreview-flex-em6o3i">
          <v-container class="transferFunds--title-padding" data-qa="internationalpaymentsreview-container-bgue57">
            <v-flex xs12 sm12 md12 lg12 xl12 data-qa="internationalpaymentsreview-flex-wfavs6">
              <v-row no-gutters data-qa="internationalpaymentsreview-row-qq9xj5">
                <v-layout row wrap class="pb-2" data-qa="internationalpaymentsreview-layout-20g4ws">
                  <v-flex xs2 sm2 md2 lg1 xl1 class="pr-6 pt-4" data-qa="internationalpaymentsreview-flex-0dvow">
                    <v-row justify="end" data-qa="internationalpaymentsreview-row-2kqpkc">
                      <v-avatar :tile="false" size="35" color="white" data-qa="internationalpaymentsreview-avatar-u5a11o">
                        <v-icon :color="primaryColor" data-qa="internationalpaymentsreview-icon-92ecng">mdi-sync</v-icon>
                      </v-avatar>
                    </v-row>
                  </v-flex>
                  <v-flex xs9 sm9 md9 lg9 xl9 class="pt-2" data-qa="internationalpaymentsreview-flex-0n4y0c">
                    <v-row no-gutters data-qa="internationalpaymentsreview-row-oqb9ii">
                      <font class="text-h5 font-weight-light white--text">
                        {{ $t("internationalPayments.title") }}</font
                      >
                    </v-row>
                  </v-flex>
                </v-layout>
              </v-row>
            </v-flex>
          </v-container>
        </v-flex>
      </v-layout>

      <v-flex
        xs12
        sm12
        md12
        lg10
        xl10
        class="pl-12 cStatement--overlayCardFlex"
       data-qa="internationalpaymentsreview-flex-482nf">
        <v-layout row wrap class="pl-12" data-qa="internationalpaymentsreview-layout-c9a8ks">
          <v-flex xs12 sm12 md12 lg10 xl10 class="pt-4" data-qa="internationalpaymentsreview-flex-tafz1e">
            <v-card data-qa="internationalpaymentsreview-card-xko1frg">
              <v-card-text class="text--primary" data-qa="internationalpaymentsreview-card-text-369yb9">
                <v-row no-gutters class="py-2" data-qa="internationalpaymentsreview-row-itg25k">
                  <DisplayDetails
                    :config="{
                      title: 'Summary',
                      dataList: summaryDetails,
                      translation: 'internationalPayments',
                    }"
                    class="pl-6"
                  />
                </v-row>
                <!-- DOCUMENT LIST -->
                <v-row v-if="documents.length" data-qa="internationalpaymentsreview-row-d48l1y">
                  <v-container class="pl-10 mb-4" data-qa="internationalpaymentsreview-container-5gfcx">
                    <div class="text-overline font-weight-bold" data-qa="internationalpaymentsreview-div-2quxca">{{ documentsLabel }}</div>
                    <div v-for="(file, i) in documents" :key="i" :data-qa="`internationalpaymentsreview-div-j4vbbr-${i}`">
                      <div :data-qa="`internationalpaymentsreview-div-70e2np-${i}`">{{ file.name }} ({{ file.displaySize }})</div>
                    </div>
                  </v-container>
                </v-row>
                <v-row
                  v-if="
                    config.payload.paymentFrequency === 'ONCE' &&
                    isFuturePayment()
                  "
                  no-gutters
                  class="px-8"
                 data-qa="internationalpaymentsreview-row-t1nlcx">
                  <v-alert
                    icon="mdi-information-outline"
                    class="v-alert--info"
                   data-qa="internationalpaymentsreview-alert-l3brd">
                    <font class="body-2 font-weight-regular">
                      {{ $t("internationalPayments.scheduledPaymentInfo") }}
                    </font>
                  </v-alert>
                </v-row>
                <v-row
                  v-if="config.payload.paymentFrequency !== 'ONCE'"
                  no-gutters
                  class="px-8"
                 data-qa="internationalpaymentsreview-row-7zl4e9">
                  <v-alert
                    icon="mdi-information-outline"
                    class="v-alert--info"
                   data-qa="internationalpaymentsreview-alert-r84fqo">
                    <font class="body-2 font-weight-regular">
                      {{ $t("internationalPayments.scheduledRecurringPaymentInfo") }}
                    </font>
                  </v-alert>
                </v-row>
              </v-card-text>

              <v-card-actions class="pl-8 pt-3 pb-8" data-qa="internationalpaymentsreview-card-actions-03bp1k">
                <v-layout wrap data-qa="internationalpaymentsreview-layout-pl6udm">
                  <v-btn
                    @click="goBack"
                    :color="primaryColor"
                    :disabled="disableBtn"
                    outlined
                    class="text-capitalize ma-2 pl-10 pr-10 py-2 px-4"
                   data-qa="internationalpaymentsreview-btn-m0zn0g">
                    {{ $t("internationalPayments.backButton") }}
                  </v-btn>
                  <v-btn
                    @click="confirmTransfer"
                    :color="primaryColor"
                    :disabled="disableBtn"
                    :width="107"
                    :height="36"
                    class="text-capitalize ma-2 pl-16 pr-16 white--text py-2 px-4"
                   data-qa="internationalpaymentsreview-btn-xunrt9">
                    {{ $t("internationalPayments.confirmButton") }}
                  </v-btn>
                </v-layout>
              </v-card-actions>
            </v-card>
          </v-flex>
        </v-layout>
      </v-flex>
      <!-- OTP -->
      <Modal
        v-if="enableOTP && showOTPScreen"
        @cancel="onOtpModalClose"
        :config="modalConfig.otp"
      >
        <span slot="modalContent" data-qa="internationalpaymentsreview-span-8kfjul">
          <OtpInput :otpConfig="otpSettings" />
        </span>
      </Modal>
      <DownloadPaymentProof v-show="showDownloadPayment" :config="paymentProofDetails"></DownloadPaymentProof>
      <!-- Success/Failure Dialog -->
      <Modal
        v-if="successDialog.show"
        :config='getPaymentSuccessDialogConfig'
        @btn1Action="handleCreateNewTransfer"
        @btn2Action="handleGotoDashboard"
        @btn3Action="downloadPaymentProofEnabled"
      >
      </Modal>
      <PaymentFailureDialog
        :show="failureDialog.show"
        :retry="false"
        :error-list="[]"
        @goBack="handleGoBack"
        @cancelTransfer="handleCancelTransfer"
      />
    </div>
  </v-flex>
</template>

<script>
import '@/styles/pages/consolidatedStatement.scss'
import commonService from '@/service/commonService.js'
import OtpInput from '@/components/common/OtpInput.vue'
import DisplayDetails from '@/views/common/DisplayDetails.vue'
import event from '@/util/event'
import moment from 'moment'
import preload from '@/util/preload'
import SEPAPaymentTemplate from '@/plugins/SEPAconfig'
import PaymentSuccessDialog from '../common/PaymentSuccessDialog.vue'
import PaymentFailureDialog from '../common/PaymentFailureDialog.vue'
import DownloadPaymentProof from '@/views/payments/paymentProof/PaymentProofFormat.vue'

const YMD = 'YYYY-MM-DD'

export default {
  name: 'InternationalPaymentsReview',
  props: {
    config: {
      type: Object,
      default: undefined
    },
    display: {
      type: Object,
      default: undefined
    },
    isInitiateSepaFailed: {
      type: Boolean,
      default: false
    },
    isQuickPay: {
      type: Boolean,
      default: false
    }
  },
  components: {
    Modal: () => import('@/components/common/Modal.vue'),
    OtpInput,
    DisplayDetails,
    PaymentSuccessDialog,
    PaymentFailureDialog,
    DownloadPaymentProof
  },
  data () {
    return {
      enableIBANAccountNumberDisplay: this.$appSettings.defaultConfigurations.enableIBANAccountNumberDisplay,
      SEPAPaymentTemplate,
      endPeriodDate: '',
      confirmAccountTransfer: true,
      successResponse: '',
      disableBtn: false,
      summaryDetails: [],
      confirmationDetails: [],
      setOTPAuthentication: this.$appSettings.defaultConfigurations,
      enableOTP: this.$appSettings.defaultConfigurations
        .enableOTPForSepaPaymentTransfer,
      currentDate: moment().format(YMD),
      showOTPScreen: false,
      otpSettings: {
        resetPasswordTime: this.$appSettings.defaultConfigurations
          .otpResendTimeInterval,
        flex: 'xs12 sm12 md12 lg12 xl12'
      },
      modalConfig: {
        otp: {
          enabled: false,
          persistent: true,
          enableSave: true,
          close: true,
          saveButton: '',
          outlinedSaveBtn: false,
          title: this.$t('otp.toolBarTitle'),
          width: 400
        },
        successModal: {
          enabled: false,
          persistent: true,
          dataListTranslation: 'internationalPayments',
          title: this.$t('paymentSuccessDialog.transferInitiated'),
          btn1Label: this.$t('paymentSuccessDialog.button.newTransfer'),
          btn2Label: this.$t('paymentSuccessDialog.button.gotoDashboard'),
          width: 700
        }
      },
      failureDialog: {
        show: false
      },
      successDialog: {
        show: false
      },
      showDownloadPayment: false,
      paymentProofDetails: {},
      downloadDataDetails: [],
      proofOfPaymentConfiguration: this.$appSettings.defaultConfigurations.proofOfPayment,
      isDownloadPaymentProofEnabled: this.$appSettings.defaultConfigurations.proofOfPayment.enableProofOfPaymentDownload
    }
  },
  created () {
    this.setSummaryData()
    this.generateEndDate(this.config.payload.frequencyMonths)
    event.$on('IS_OTP_VALID', (val) => {
      this.modalConfig.otp.enabled = true
      this.saveTransferData()
    })
    event.$on('retry_transfer', (val) => {
      this.confirmTransfer()
    })
    event.$on('close_otp', (val) => {
      this.onOtpModalClose()
    })
    if (this.isDownloadPaymentProofEnabled) {
      this.modalConfig.successModal.btn3Label = this.$t('paymentSuccessDialog.button.download')
    }
  },
  methods: {
    setSummaryData () {
      const { payload } = this.config
      this.summaryDetails = []
      this.summaryDetails.push(
        {
          label: 'fromLabel',
          value: payload.fromAccount.selectedAccountText,
          subValue: payload.fromAccount.selectedAccountHintText
        },
        {
          label: this.isQuickPay ? 'selectPayeeLabel' : 'toLabel',
          value: this.isQuickPay ? payload.toAccName : this.display.viewOnly.payeeAccountName,
          subValue: !this.isQuickPay ? `(${this.display.viewOnly.senderAccName})` : `(${this.display.viewOnly.senderAccName} | ${payload.bicCode})`
        },
        {
          label: 'amountLabel',
          value: this.$formatter.currency.format(
            payload.transferAmount,
            payload.currencyFormat
          )
        }
      )
      if (payload.internationalPaymentCharges !== undefined) {
        this.summaryDetails.push({
          label: 'charge',
          value: this.$formatter.currency.format(
            payload.internationalPaymentCharges,
            payload.currencyFormat
          )
        })
        this.downloadDataDetails.push({
          label: 'charges',
          value: this.$formatter.currency.format(
            payload?.internationalPaymentCharges,
            payload?.currencyFormat
          )
        })
      }
      if (payload.paymentFrequency !== 'ONCE') {
        this.summaryDetails.push(
          {
            label: 'frequencyDaysLabel',
            value: payload.paymentFrequency
          },
          {
            label: 'selectTimes',
            value: payload.frequencyMonths
          }
        )
      }
      this.summaryDetails.push({
        label:
          payload.paymentFrequency !== 'ONCE'
            ? 'paymentStartDate'
            : 'quickPaymentDateLabel',
        value: this.$formatter.formatDate(payload.startDate)
      })
      this.summaryDetails.push({
        label: 'reviewNoteLabel',
        value: payload.transferNote
      })
    },
    setConfirmationData () {
      this.downloadDataDetails = []
      const { payload } = this.config
      this.confirmationDetails.push(
        {
          label: 'fromLabel',
          value: payload.fromAccount.selectedAccountText,
          subValue: payload.fromAccount.selectedAccountHintText
        },
        {
          label: 'toLabel',
          value: this.display.viewOnly.payeeAccountName,
          subValue: `(${this.display.viewOnly.senderAccName})`
        },
        {
          label: 'amountLabel',
          value: this.$formatter.currency.format(
            payload.transferAmount,
            payload.currencyFormat
          )
        }
      )
      this.downloadDataDetails.push(
        {
          label: 'fromAcc',
          value: payload?.fromAccount?.selectedAccountText,
          subValue: this.$formatter.maskNumber(payload?.fromAccount?.accountId)
        },
        {
          label: 'toAcc',
          value: this.display.viewOnly.payeeAccountName,
          subValue: `(${this.$formatter.maskNumber(payload?.toAcc)} | ${payload?.payeeSortCode})`
        },
        {
          label: 'amount',
          value: this.$formatter.currency.format(
            payload?.transferAmount,
            payload?.currencyFormat
          )
        }
      )
      if (payload.paymentFrequency !== 'ONCE') {
        this.confirmationDetails.push(
          {
            label: 'frequencyDaysLabel',
            value: payload.paymentFrequency
          },
          {
            label: 'selectMonthsLabel',
            value: payload.frequencyMonths
          },
          {
            label: 'paymentStartDate',
            value: this.$formatter.formatDate(payload.startDate)
          }
        )
        this.downloadDataDetails.push(
          {
            label: 'frequency',
            value: payload?.paymentFrequency
          },
          {
            label: 'noOfPayments',
            value: payload?.frequencyMonths
          }
        )
      } else {
        this.confirmationDetails.push(
          {
            label: 'quickPaymentDateLabel',
            value: this.$formatter.formatDate(payload.startDate)
          }
        )
      }
      this.confirmationDetails.push(
        {
          label: 'reviewNoteLabel',
          value: payload.transferNote
        }
      )
    },
    downloadPaymentProofEnabled () {
      let dataDetails = []
      this.downloadDataDetails.push({
        label: (this.config?.payload?.paymentFrequency !== 'ONCE') ? 'paymentStartDate' : 'paymentDate',
        value: this.isFuturePayment() ? this.$formatter.formatDate(this.config?.payload?.startDate) : `${this.$formatter.formatDate(this.config?.payload?.startDate)} / ${this.successResponse?.paymentTime}`
      })
      let titleContentDetails = [
        { label: this.$t('proofOfPayment.label.transactionRef'), value: (this.successResponse.standingOrderId || this.successResponse.transactionReference) },
        { label: this.$t('proofOfPayment.label.transactionStatus'), value: this.$t('proofOfPayment.value.processing') }
      ]
      const exclusionList = this.proofOfPaymentConfiguration.exclusionList
      dataDetails = this.downloadDataDetails?.filter(item => !exclusionList.includes(item.label))
      this.paymentProofDetails = {
        dataDetails,
        titleContentDetails,
        dataListTranslation: 'proofOfPayment.label',
        title: this.$t(this.proofOfPaymentConfiguration.payment_title),
        contentTitle: this.$t(this.proofOfPaymentConfiguration.payment_contentTitle),
        transactionId: (this.successResponse.standingOrderId || this.successResponse.transactionReference)
      }
      event.$emit('download_payment_proof', this.paymentProofDetails)
      // this.showDownloadPayment = true
    },
    onOtpModalClose () {
      this.modalConfig.otp.enabled = false
      this.disableBtn = false
      this.showOTPScreen = false
    },
    generateEndDate (val) {
      const calcDays = Number(val)
      const frequencyList = this.config.payload.paymentFrequency
      const startDate = this.config.payload.startDate
      const endDateMoment = moment(startDate)
      switch (frequencyList) {
        case 'ONCE':
          this.endPeriodDate = endDateMoment
            .add(calcDays + 2, 'days')
            .format(YMD)
          break
        case 'DAILY':
          this.endPeriodDate = endDateMoment
            .add(calcDays + 2, 'days')
            .format(YMD)
          break
        case 'BI-MONTHLY':
          var timeMonths = Math.ceil(calcDays / 2)
          this.endPeriodDate = endDateMoment
            .add(timeMonths, 'months')
            .format(YMD)
          break
        case 'MONTHLY':
          this.endPeriodDate = endDateMoment
            .add(calcDays, 'months')
            .format(YMD)
          break
        case 'QUARTERLY':
          this.endPeriodDate = moment(startDate)
            .quarter(calcDays + 1)
            .endOf('quarter')
            .format(YMD)
          break
        case 'HALF-YEARLY':
          var timeHalfYearly = Math.ceil(calcDays / 2)
          this.endPeriodDate = endDateMoment
            .add(timeHalfYearly, 'years')
            .format(YMD)
          break
        case 'YEARLY':
          this.endPeriodDate = endDateMoment
            .add(calcDays, 'years')
            .format(YMD)
          break
        default:
          console.log('ERROR')
      }
    },
    confirmTransfer () {
      this.disableBtn = true
      if (this.enableOTP) {
        this.showOTPScreen = true
        this.modalConfig.otp.enabled = true
      } else {
        this.saveTransferData()
      }
      this.$emit('reset_isInitiateSepaFailed', true)
    },
    newTransferRequest () {
      this.successDialog.show = false
      event.$emit('IS_REVIEW_CLEAR', { type: 'Reset' })
    },
    async returnToDashboard () {
      await preload.getListOfAccounts(
        JSON.parse(sessionStorage.getItem('username'))
      )
      this.$router.push('/home')
    },
    goBack () {
      event.$emit('IS_REVIEW_CLEAR', 'GoBack')
    },
    isFuturePayment () {
      return this.config.payload.startDate !== this.currentDate
    },
    saveTransferData () {
      // this.onOtpModalClose()
      if (
        this.config.payload.paymentFrequency === 'ONCE' &&
        this.config.payload.startDate === this.currentDate
      ) {
        this.createFundTransfer()
      } else {
        this.createStandingOrder()
      }
    },
    async createFundTransfer () {
      this.$emit('sepaPaymentSuccessfull', true)
    },
    async createStandingOrder () {
      let repeatPaymentData
      const oneTimePaymentData = {
        startDate: this.config.payload.startDate,
        endDate: this.endPeriodDate,
        frequency:
          this.config.payload.paymentFrequency === 'ONCE'
            ? 'DAILY'
            : this.config.payload.paymentFrequency,
        transferFromAccountDetails: [
          {
            accountId: this.config.payload.fromAcc,
            amount: {
              value: this.config.payload.transferAmount,
              currency: this.SEPAPaymentTemplate.currency
            }
          }
        ],
        transferToAccountDetails: [
          {
            accountId: this.config.payload.toAcc,
            amount: {
              value: this.config.payload.transferAmount,
              currency: this.SEPAPaymentTemplate.currency
            }
          }
        ]
      }
      repeatPaymentData = {
        customerId: JSON.parse(sessionStorage.getItem('username')), // customer Id
        description: this.config.payload.transferNote,
        paymentInstruction: {
          paymentSystem: this.SEPAPaymentTemplate.paymentSystem, // UKFPS or STEP2 from Payment Template
          paymentType: 'Credit Transfer', // ImmediatePayement for UKFPS, Credit Transfer for SEPA
          destinationCountry: this.config.payload.toAcc.substring(0, 2) || this.SEPAPaymentTemplate.country, // from Payment Template
          instructionAmount: {
            amount: Number(this.config.payload.transferAmount).toFixed(2), // amount input
            currency: this.SEPAPaymentTemplate.currency // amount currency
          },
          chargeAmount: {
            amount: 0.00,
            currency: 'EUR'
          },
          taxAmount: {
            amount: 0.00,
            currency: 'EUR'
          },
          debtorCustomerReference: this.config.payload.transferNote, // FBPY-7526 FBPY-7535 - narrative
          debtorAccountType: 'PROPRIETARY',
          debtorAccount: this.config.payload.fromAcc, // From Account number
          debtorBankIdentifier: this.SEPAPaymentTemplate.standingOrderSetups.debtorBankIdentifier,
          cdtrName: this.display.viewOnly.payeeAccountName, // Payee Name
          cdtrAccountType: this.SEPAPaymentTemplate.accountIdentificationType, // PROPRIETARY for UKFPS, IBAN for SEPA
          cdtrAccount: this.config.payload.toAcc, // To Account -  IBAN Account Number for SEPA
          cdtrAddress: {
            CdtrPstlAdrAdrTp: 'RESIDENTIAL',
            CdtrPstlAdrCtry: this.config.payload.toAcc.substring(0, 2) || this.SEPAPaymentTemplate.country // from Payment Template
          },
          cdtrBankIdentifier: this.config.payload.payeeSortCode, // payee sort code
          remittanceInfoCtgyPurp: this.SEPAPaymentTemplate.standingOrderSetups.remittanceInfoCtgyPurp, // from payment template
          chargesWaived: this.SEPAPaymentTemplate.standingOrderSetups.chargesWaived // from payment template
        },
        standingOrderSetup: {
          frequency: this.config.payload.paymentFrequency, // input
          numberOfPayments: this.config.payload.frequencyMonths, // input
          fromDate: this.config.payload.startDate, // input
          payTillFurtherNotice: false,
          executionTime: '1100',
          setupCharge: this.SEPAPaymentTemplate.standingOrderSetups.setupCharge, // from payment template
          amendCharge: this.SEPAPaymentTemplate.standingOrderSetups.amendCharge, // from payment template
          successCharge: this.SEPAPaymentTemplate.standingOrderSetups.successCharge, // from payment template
          failureCharge: this.SEPAPaymentTemplate.standingOrderSetups.failureCharge // from payment template
        },
        channelId: 'DOB' // DOB or DMB
      }
      // Append endOfMonth flag - Only for MONTHLY frequency
      if (this.config.payload.paymentFrequency === 'MONTHLY') {
        repeatPaymentData.standingOrderSetup.endOfMonth = true
      }
      if (this.config.payload.paymentFrequency === 'ONCE' && this.currentDate !== this.config.startDate) {
        repeatPaymentData.standingOrderSetup.frequency = 'DAILY'
        repeatPaymentData.standingOrderSetup.numberOfPayments = 1
      }
      const response = this.config.payload.paymentFrequency === 'ONCE' && this.currentDate === this.config.startDate
        ? await commonService.postStandingOrder(oneTimePaymentData)
        : await commonService.interBankCreateStandingOrder(repeatPaymentData)

      if (!response) return
      if (response?.causes?.[0]?.code === '20600123') {
        this.onOtpModalClose()
        this.dispatchError({ content: this.$t('systemMessages.customMessages.20600123.message'), title: this.$t('systemMessages.customMessages.20600123.title') })
        return
      }
      if (response?.causes?.[0]?.code === '20600256') return

      if (response && response.internalType === 'OTP-ERROR') {
        event.$emit('otp_validation_failed', response)
        return
      }

      this.onOtpModalClose()

      this.successDialog.show = !!(response.standingOrderId || response.transactionReference)
      this.failureDialog.show = !this.successDialog.show
      this.successResponse = response
      event.$emit('is_SEPA_TransferComplete', true)
      this.setConfirmationData()
      // await preload.getListOfAccounts(JSON.parse(sessionStorage.getItem('username')))
    },
    dispatchError ({ content, title = 'Error' }) {
      this.$store.dispatch('appStore/setAppData', {
        message: {
          title,
          width: 400,
          persistent: true,
          saveButton: this.$t('common.okay'),
          content,
          type: 'error',
          component: 'dob-modal'
        }
      })
    },
    formatDisplayedFromAccount (accountType) {
      const account = this.enableIBANAccountNumberDisplay
        ? this.config.payload.fromAccIBAN
          ? this.config.payload.fromAccIBAN : this.config.payload.fromAcc
        : this.config.payload.fromAcc
      let label = ''
      label = this.$t('termDepositActions.listAC.savingsLabel')
      if (accountType === 'CACC') {
        label = this.$t('termDepositActions.listAC.currentLabel')
      }
      if (accountType === 'TXSV') {
        label = this.$t('termDepositActions.listAC.cashIsaLabel')
      }
      return `${label} - ${account}`
    },
    async handleCreateNewTransfer () {
      this.showSuccessDialog = false
      this.reviewScreen = false
      this.newTransferRequest()
      await preload.getListOfAccounts(JSON.parse(sessionStorage.getItem('username')))
    },
    async handleGotoDashboard () {
      this.showSuccessDialog = false
      this.reviewScreen = false
      this.loaderEnabled = true
      await preload.getListOfAccounts(JSON.parse(sessionStorage.getItem('username')))
      this.isTransferComplete = true
      this.$router.push('/home')
    },
    handleGoBack () {
      this.failureDialog.show = false
      this.failureDialog.errorList = []
    },
    handleCancelTransfer () {
      this.failureDialog.show = false
      this.failureDialog.errorList = []
      this.reviewScreen = false
      this.newTransferRequest()
    }
  },
  computed: {
    documents () {
      return this.config.payload.supplementaryDocuments
    },
    documentsLabel () {
      return this.settings.required ? this.$t('swiftPayments.documents') : this.$t('swiftPayments.documentsOptional')
    },
    settings () {
      return {
        docCategory: this.$appSettings.defaultConfigurations.supplementaryDocuments.docCategory,
        docType: this.$appSettings.defaultConfigurations.supplementaryDocuments.docType,
        maxUploadRetryCount: this.$appSettings.defaultConfigurations.supplementaryDocuments.maxUploadRetryCount,
        required: this.$appSettings.defaultConfigurations.supplementaryDocuments.required,
        businessType: this.$appSettings.defaultConfigurations.supplementaryDocuments.SEPA.businessType
      }
    },
    getPaymentSuccessDialogConfig () {
      return {
        ...this.modalConfig.successModal,
        enabled: this.successDialog.show,
        dataDetails: this.confirmationDetails,
        body: this.$t('paymentSuccessDialog.yourTransactionReference') + ' ' + (this.successResponse.standingOrderId || this.successResponse.transactionReference)
      }
    }
  },
  watch: {
    showOTPScreen () {
      if (this.enableOTP && this.showOTPScreen) {
        setTimeout(() => {
          event.$emit('SEND_OTP', true)
        }, 200)
      }
    },
    isInitiateSepaFailed: {
      handler (val) {
        this.disableBtn = !val
      }
    }
  },
  beforeDestroy () {
    event.$off('IS_OTP_VALID')
    event.$off('download_payment_proof')
  }
}
</script>
